<template>
  <b-card class="mb-3 shadow-sm" no-body>
    <b-card-header v-b-toggle="'collapse-' + option.key" class="collapse-header">
      <p class="d-inline">{{$t(`views.requests.${option.key}.label`)}}</p>
      <netvs-icon style="float: right" class="collapse-icon" icon="collapse"></netvs-icon>
    </b-card-header>

    <b-collapse :id="'collapse-' + option.key" class="mt-2">
      <b-card-body>
        <p v-html="$t(`views.requests.${option.key}.description`)"></p>
      </b-card-body>

      <component :is="option.modal"></component>
    </b-collapse>
    <b-card-footer>
      <div class="text-alert no-perm text-center mb-2" v-if="option.disabled_text && option.disabled_text()">
        {{ $t(option.disabled_text()) }}
      </div>
      <b-button v-if="option.disabled_text && option.disabled_text()" variant="outline-secondary" block disabled class="cursor-disabled" > {{
          $t(`views.requests.${option.key}.label`)
        }}
      </b-button>
      <b-button v-else variant="primary" block :href="option.address" v-b-modal="option.modal_id">{{
          $t(`views.requests.${option.key}.label`)
        }}
        <netvs-icon v-if="option.address" icon="external_link"/>
        <b-badge v-if="option.badge_content" variant="light" pill>{{ option.badge_content }}</b-badge>
      </b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'RequestCard',
  props: {
    option: {
      required: true,
      default() {
        return null
      }
    }
  }
})
</script>
<style scoped>
.cursor-disabled {
  cursor: not-allowed;
}
.no-perm {
  color: var(--red);
}
</style>
